module.exports = __webpack_public_path__ + "static/media/share.99bb9674.svg";